var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"FlatButton",class:_vm.getClasses(),style:(("width: " + _vm.width + ";")),attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.click}},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }